/* tslint:disable */
/* eslint-disable */
/**
 * Bonds API
 * Microservice backend for bond management
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReturnCollectionStateEnum } from './ReturnCollectionStateEnum';
import {
    ReturnCollectionStateEnumFromJSON,
    ReturnCollectionStateEnumFromJSONTyped,
    ReturnCollectionStateEnumToJSON,
} from './ReturnCollectionStateEnum';
import type { ReturnCreate } from './ReturnCreate';
import {
    ReturnCreateFromJSON,
    ReturnCreateFromJSONTyped,
    ReturnCreateToJSON,
} from './ReturnCreate';
import type { ReturnTypesEnum } from './ReturnTypesEnum';
import {
    ReturnTypesEnumFromJSON,
    ReturnTypesEnumFromJSONTyped,
    ReturnTypesEnumToJSON,
} from './ReturnTypesEnum';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);
/**
 * 
 * @export
 * @interface ReturnCollectionCreate
 */
export interface ReturnCollectionCreate {
    /**
     * 
     * @type {number}
     * @memberof ReturnCollectionCreate
     */
    readonly id: number;
    /**
     * 
     * @type {Array<ReturnCreate>}
     * @memberof ReturnCollectionCreate
     */
    returns: Array<ReturnCreate>;
    /**
     * 
     * @type {string}
     * @memberof ReturnCollectionCreate
     */
    periodicity: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReturnCollectionCreate
     */
    issue: number | null;
    /**
     * 
     * @type {Date}
     * @memberof ReturnCollectionCreate
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReturnCollectionCreate
     */
    readonly updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReturnCollectionCreate
     */
    readonly deleted: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReturnCollectionCreate
     */
    readonly deletedByCascade: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReturnCollectionCreate
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ReturnCollectionCreate
     */
    period?: number;
    /**
     * 
     * @type {number}
     * @memberof ReturnCollectionCreate
     */
    periodYear?: number;
    /**
     * 
     * @type {Date}
     * @memberof ReturnCollectionCreate
     */
    periodDate?: Date;
    /**
     * 
     * @type {Array<ReturnTypesEnum>}
     * @memberof ReturnCollectionCreate
     */
    returnTypes: Array<ReturnTypesEnum>;
    /**
     * 
     * @type {ReturnCollectionStateEnum}
     * @memberof ReturnCollectionCreate
     */
    collectionState?: ReturnCollectionStateEnum;
    /**
     * 
     * @type {number}
     * @memberof ReturnCollectionCreate
     */
    company?: number;
}

/**
 * Check if a given object implements the ReturnCollectionCreate interface.
 */
export function instanceOfReturnCollectionCreate(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('returns' in value)) return false;
    if (!('periodicity' in value)) return false;
    if (!('issue' in value)) return false;
    if (!('createdAt' in value)) return false;
    if (!('updatedAt' in value)) return false;
    if (!('deleted' in value)) return false;
    if (!('deletedByCascade' in value)) return false;
    if (!('name' in value)) return false;
    if (!('returnTypes' in value)) return false;
    return true;
}

export function ReturnCollectionCreateFromJSON(json: any): ReturnCollectionCreate {
    return ReturnCollectionCreateFromJSONTyped(json, false);
}

export function ReturnCollectionCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReturnCollectionCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'returns': ((json['returns'] as Array<any>).map(ReturnCreateFromJSON)),
        'periodicity': json['periodicity'],
        'issue': json['issue'],
        'createdAt': (dayjs(json['created_at']).toDate()),
        'updatedAt': (dayjs(json['updated_at']).toDate()),
        'deleted': (json['deleted'] == null ? null : dayjs(json['deleted']).toDate()),
        'deletedByCascade': json['deleted_by_cascade'],
        'name': json['name'],
        'period': json['period'] == null ? undefined : json['period'],
        'periodYear': json['period_year'] == null ? undefined : json['period_year'],
        'periodDate': json['period_date'] == null ? undefined : (dayjs.tz(json['period_date'], 'YYYY-MM-DD', dayjs.tz.guess()).toDate()),
        'returnTypes': ((json['return_types'] as Array<any>).map(ReturnTypesEnumFromJSON)),
        'collectionState': json['collection_state'] == null ? undefined : ReturnCollectionStateEnumFromJSON(json['collection_state']),
        'company': json['company'] == null ? undefined : json['company'],
    };
}

export function ReturnCollectionCreateToJSON(value?: ReturnCollectionCreate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'returns': ((value['returns'] as Array<any>).map(ReturnCreateToJSON)),
        'periodicity': value['periodicity'],
        'issue': value['issue'],
        'name': value['name'],
        'period': value['period'],
        'period_year': value['periodYear'],
        'period_date': value['periodDate'] == null ? undefined : (dayjs(value['periodDate'] as any).format('YYYY-MM-DD')),
        'return_types': ((value['returnTypes'] as Array<any>).map(ReturnTypesEnumToJSON)),
        'collection_state': ReturnCollectionStateEnumToJSON(value['collectionState']),
        'company': value['company'],
    };
}

